<template>
  <el-card class="box-card">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('order.list.tabAll')" name="0">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==0' />
      </el-tab-pane>
      <el-tab-pane :label="$t('order.list.tabWaitPrint')" name="4">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==4' />
      </el-tab-pane>
      <el-tab-pane :label="$t('order.list.tabWaitShip')" name="1">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==1' />
      </el-tab-pane>
      <el-tab-pane :label="$t('order.list.tabShipped')" name="2">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==2' />
      </el-tab-pane>
      <el-tab-pane v-for="status in [7, 8, 9, 10]" :key="status" :label="$t('logistics.status' + status)" :name="String(status)">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==status' />
      </el-tab-pane>
      <el-tab-pane :label="$t('order.list.tabCancelled')" name="3">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==3' />
      </el-tab-pane>
      <el-tab-pane :label="$t('order.list.tabRefunded')" name="5">
        <OrderList @changelist="changelist" :activeName='activeName' v-if='activeName==5' />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
  import OrderList from './components/orderList.vue';
  export default {
    components: {
      OrderList
    },
    data() {
      return {
        activeName: '0'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      changelist(num){
        this.activeName = num
      }
    }
  };
</script>
